<template>
  <div id="app">
    <canvas ref="codeRainCanvas" class="global-code-rain"></canvas>
    <NavBar />
    <main>
      <router-view />
    </main>
  </div>
</template>

<script>
import NavBar from './components/NavBar.vue'

export default {
  name: 'App',
  components: {
    NavBar,
  },
  mounted() {
    this.initCodeRain()
  },
  beforeUnmount() {
    if (this._rainTimer) cancelAnimationFrame(this._rainTimer)
    if (this._resizeHandler) window.removeEventListener('resize', this._resizeHandler)
  },
  methods: {
    initCodeRain() {
      const canvas = this.$refs.codeRainCanvas
      if (!canvas) return
      const ctx = canvas.getContext('2d')
      const chars = '가나다라마바사아자카타파하01アイウエオカキクケコ10XOULAGENT=+{}[]<>코드워크플로우'
      const fontDraw = 14   // 글자 크기
      const colWidth = 24    // 열 간격
      const trailLen = 30
      let columns = 0, drops = [], trails = []

      const initDrops = (count) => {
        const maxRow = Math.ceil(window.innerHeight / colWidth)
        drops = Array(count).fill(0).map(() => Math.floor(Math.random() * maxRow) - maxRow)
        trails = Array.from({ length: count }, () => [])
      }

      const resize = () => {
        canvas.width = window.innerWidth
        canvas.height = window.innerHeight
        const newCols = Math.floor(canvas.width / colWidth)
        if (newCols !== columns) {
          // 열 수가 바뀔 때만 재초기화
          columns = newCols
          initDrops(columns)
        }
      }
      resize()
      this._resizeHandler = resize
      window.addEventListener('resize', resize)

      const draw = () => {
        // 매 프레임 배경색으로 완전 덮기 → 잔상 원천 차단
        ctx.fillStyle = '#0d0d0d'
        ctx.fillRect(0, 0, canvas.width, canvas.height)

        for (let i = 0; i < columns; i++) {
          const y = drops[i]
          if (y >= 0) {
            // 새 문자를 트레일에 추가
            const char = chars[Math.floor(Math.random() * chars.length)]
            trails[i].push({ char, y: y * colWidth })
            // 트레일 길이 제한
            if (trails[i].length > trailLen) trails[i].shift()
          }

          // 트레일 그리기 (뒤→앞, 점점 밝게)
          ctx.font = `${fontDraw}px 'Fira Code', monospace`
          for (let j = 0; j < trails[i].length; j++) {
            const t = trails[i][j]
            const ratio = j / trails[i].length  // 0(어두움) → 1(밝음)
            const alpha = 0.03 + ratio * 0.30
            ctx.fillStyle = `rgba(80, 200, 120, ${alpha})`
            ctx.fillText(t.char, i * colWidth, t.y)
          }

          // 드롭 이동
          drops[i] += 0.25
          if (drops[i] * colWidth > canvas.height && Math.random() > 0.98) {
            drops[i] = -Math.random() * 10
            trails[i] = []
          }
        }
        this._rainTimer = requestAnimationFrame(draw)
      }
      draw()
    },
  },
}
</script>

<style>
#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  position: relative;
}

.global-code-rain {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  pointer-events: none;
  z-index: 0;
  opacity: 0.7;
}

main {
  flex: 1;
  padding-top: 56px;
  position: relative;
  z-index: 1;
}
</style>
